import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "fio" }
const _hoisted_3 = { class: "personal-info-container" }
const _hoisted_4 = { class: "params" }
const _hoisted_5 = { class: "experience" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { type: "submit" }

import {reactive, ref} from "vue";
import TextInput from "@/components/inputs/TextInput.vue";
import DateInput from "@/components/inputs/DateInput.vue";
import PhoneInput from "@/components/inputs/PhoneInput.vue";
import SwitchInput from "@/components/inputs/SwitchInput.vue";
import api from "@/api";
import {NewbieApplicationDTO} from "@/classes/NewbieApplicationDTO";
import {bus} from "@/utils/event-bus";
import {useLocalization} from "@/utils/useLocalization";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewbieApplication',
  setup(__props) {


const {t} = useLocalization()

const initialState = {
  lastName: '',
  firstName: '',
  middleName: '',
  phone: '',
  email: '',
  telegram: '',
  birthDate: '',
  height: '',
  weight: '',
  knowsRules: false,
  experience: '',
  description: '',
}
const data = reactive({
  ...initialState
})
const send = async () => {
  const response = await api.application.newbie(new NewbieApplicationDTO().map(data))
      .then(s => s.Application)
      .catch(e => e.response)

  if (response === 'ok') {
    bus.emit('alert', {
      type: 'success',
      header: 'Success',
      message: 'Успешно отправили заявку',
      iconSize: null,
      iconStyle: null
    })
    resetForm()
  } else {
    bus.emit('alert', {
      type: 'error',
      header: 'Failed',
      message: 'Не смогли отправить заявку. ' + response.data.message,
      iconSize: null,
      iconStyle: null
    })
  }
}

const datePicked = (event: string) => {
  data.birthDate = event
}

const resetForm = () => {
  Object.assign(data, initialState)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(send, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TextInput, {
          modelValue: data.lastName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.lastName) = $event)),
          name: 'Фамилия',
          required: ""
        }, null, 8, ["modelValue"]),
        _createVNode(TextInput, {
          modelValue: data.firstName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.firstName) = $event)),
          name: 'Имя',
          required: ""
        }, null, 8, ["modelValue"]),
        _createVNode(TextInput, {
          modelValue: data.middleName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.middleName) = $event)),
          name: 'Отчество'
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(PhoneInput, {
          type: "text",
          name: 'Телефон',
          modelValue: data.phone,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.phone) = $event)),
          required: ""
        }, null, 8, ["modelValue"]),
        _createVNode(TextInput, {
          type: "email",
          name: 'Почта',
          modelValue: data.email,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.email) = $event)),
          required: ""
        }, null, 8, ["modelValue"]),
        _createVNode(TextInput, {
          type: "text",
          name: 'Телеграм',
          modelValue: data.telegram,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.telegram) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(DateInput, {
          name: 'Выберите дату рождения',
          onPick: _cache[6] || (_cache[6] = ($event: any) => (datePicked($event)))
        }),
        _createVNode(TextInput, {
          type: "text",
          name: 'Рост',
          modelValue: data.height,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((data.height) = $event)),
          required: ""
        }, null, 8, ["modelValue"]),
        _createVNode(TextInput, {
          type: "text",
          name: 'Вес',
          modelValue: data.weight,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((data.weight) = $event)),
          required: ""
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(SwitchInput, {
          caption: 'Знаете ли Вы правила игры',
          modelValue: data.knowsRules,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((data.knowsRules) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(TextInput, {
          type: "text",
          name: 'Спортивный опыт, достижения',
          modelValue: data.experience,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((data.experience) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(TextInput, {
          type: "text",
          name: 'Расскажите о себе',
          modelValue: data.description,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((data.description) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", _hoisted_7, _toDisplayString(_unref(t)('Отправить')), 1)
      ])
    ], 32)
  ]))
}
}

})